import { template } from "babel-core";

// en.js
export default {
  message: {
    commonUsage: {
      confirm: "Confirm",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      yes: "Yes",
      no: "No",
      search: "Search",
      deleteConfirmMsg: "Confirm Deletion?",
      addConfirmTitle: "Confirm Save",
      addConfirmContent: "Confirm Save?",
      delConfirmContent: "Confirm Delete?",
      cancelDelMsg: "Cancel Delete",
      next: "Next",
      previous: "Previous",
      close: "Close",
      total: "Total",
      records: "records",
      successfullySaved: "Successfully Saved！",
      failedSaved: "Error Saved！",
      deleteSuccess: "Delete Success！",
      year: "year",
      month: "month",
      day: "day",
      operation: "Operation",
      province: "Province",
      city: "City",
      region: "Region",
      detail: "Detail",
      pause: "Pause",
      pause1: "Pause",
      copy: "Copy",
      top: "Top",
      notTop: "Cancel Top",
      remark: "Remark",
      clearFilter: "Clear the filter",
      type: "Type",
      status: "Status",
      export: "Export",
      unit: "Unit",
      add: "Add",
      operator: "Operator",
      image: "Image",
      noLimit: "No Limit",
      fixedDate: "Fixed Date",
      relativeDate: "Relative Date",
      relativeTime: "Relative Time",
      piece: "Piece",
      refresh: "Refresh",
      download: "Download",
      uploadFile: "Upload File",
      serialNumber: "Serial Number",
      audit: "Audit",
      cancelAudit: "Cancel Audit",
      run: "Run",
      stop: "Stop",
      back: "Back",
      tip: "Tip",
      detailAddress: "Detail Address",
      createTime: "Created at",
      startTime: "Start Time",
      endTime: "End Time",
      explanation: "Explanation",
      way: "Way",
      mobile: "Mobile",
      email: "Email",
      mail: "Mail",
      sms: "SMS",
      conditions: "Conditions",
      clickToUpload: "Click to upload",
      upload: "Upload",
      uploadSuccess: "Upload Success",
      uploadFail: "Upload Failed",
      uploading: "Uploading",
      reset: "Reset",
      preview: "Preview",
      template: "Template",
      today:'Today',
      sunday:'S',
      monday:'M',
      tuesday:'T',
      wednesday:'W',
      thursday:'T',
      friday:'F',
      saturday:'S',
      disable: "Disable",
      enable: "Enable",
    },
    loginPage: {
      loginBtn: "Log In",
      logOut: "Log Out",
      chooseAnotherAccount: "You are currently logged in with an account, do you want to logout and login with a different account?",
      usernameTip: "Please Enter Email!",
      passwordTip: "Please Enter Password!",
      passwordCharacters: "Please enter a password of at least 8 characters",
      passwordFormat:
        "Password: Numbers, lowercase letters, and special characters required. Please re-enter.",
      username: "Username",
      password: "Password",
      loginFailed: "Login failed",
      loginFailedMsg: "Incorrect username or password",
      loginFailedMsg1: "Username cannot be empty",
      changePassword: "Change password",
      oldPassword: "Old password",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      oldPasswordTip: "Please enter your old password!",
      newPasswordTip: "Please enter your new password!",
      confirmPasswordTip: "Please enter the confirmed password!",
      oldPasswordCharacters:
        "Please enter a password of at least 8 characters",
      newPasswordCharacters:
        "Please enter a password of at least 8 characters",
      confirmPasswordCharacters:
        "Please enter a password of at least 8 characters",
      passwordFormatError: "Incorrect password format",
      confirmPasswordError:
        "The confirmed password does not match the new password",
      passwordChangeSuccess: "Password changed successfully",
      passwordChangeFailed: "Failed to change password",
      passwordChangeFailedMsg: "Incorrect old password",
      passwordChangeFailedMsg1:
        "The new password is the same as the old password",
      passwordChangeFailedMsg2:
        "The new password does not match the confirmed password",
    },
    header: {
      styleName: "Customized",
      style1: "Customized Style",
      style2: "Standard Style",
      style3: "Customized Style 2",
      changePassword: "Change Password",
      changeTimezone: "Change Timezone",
      subscriptionList: "Subscription List",

      signOut: "Sign Out",
      language: "Language",
      chinese: "Chinese",
      english: "English",
    },
    customGroup: {
      title1: "Data Analysis",
      title2: "Customized Audience",
      title3: "Count",
      title4: "Name",
      title5: "Audience ID",
      title6: "Count",
      title7: "Save",
      title8: "Fill Content",
      SaveAudience: "Save Audience",
      SaveCombineAudience: "Save Combine Audience",
      Cancel: "Cancel",
      Save: "Save",
      UserCount: "Count",
      people: " people",
      CalculationType: "Calculation Type",
      Dynamic: "Dynamic",
      Static: "Fixed",
      DynamicTip:
        "Update User Count Daily,Recommended for Audience Monitoring.",
      StaticTip:
        "Maintain Users for Aud.,Update Tag Data Daily,Recommended for Fixed Pop. Analysis.",
      AudienceIDGenerate: "Audience ID Generate",
      Manually: "Manually",
      Autogen: "Automatic Generate",
      AudienceIDRange: "Audience ID Range",
      FillinAudienceName: "Fill in Audience Name",
      SelectCalculationType: "Select Calculation Type",
      SelectAudienceIDGenerationMethod: "Select Audience ID Generation Method",
      FillintheAudienceID: "Fill in the Audience ID",
      TheTotalAudienceCountIs: "The total audience count is ",
    },
    noPermissionPage: {
      title: "No Permission",
    },
    addUserGroup: {
      AudienceExploration: "Create Audience",
      FilterExploration: "Filter Exploration",
      softLabel: "Soft Label",
      SelectLabel: "Select",
      SelectCalculationRule: "Select Calculation Rule",
      SearchTags: "Search Labels",
      EnterSearchKeywords: "Enter Search Keywords",
      CompletetheForm: "Complete the Form",
      SelectTagValue: "Select Label Value",
      SelectMultipleAllowed: "Select(Multiple Selections Allowed)",
      DynamicTime: "Dynamic Time",
      SelectDate: "Select Date",
      MyTags: "My Labels",
      AddFilteringModule: "Add",
      PreviewandSave: "Preview and Save",
      temporarySave: "temporary save",
      CompletetheConditions: "Complete the Conditions!",
      tip1:'Please delete the conditions related to the "Disabled" tag!',
      TagID: "Label ID",
      ChineseTagName: "Label Name",
      EnterChineseTagName: "Enter Label Name",
      EnterTagID: "Enter Label ID",
      search: "Search",
      TagDisplay: "Display",
      TagList: "Label List",
      Tag: "Label",
      Favorite: "Favorite",
      IfBookmark: "Add to favorite?",
      CancelBookmarking: "Cancel Bookmarking?",
      Cancel: "Cancel",
      Confirm: "Confirm",
      AndCnd: 'Add "AND" ',
      OrCnd: 'Add "OR"',
      InInterval: "In Interval",
      EqualsTo: "Equals To",
      NotEqualTo: "Not Equal To",
      GreaterThan: "Greater Than",
      GreaterThanOrEqualTo: "Greater than or Equal to",
      LessThan: "Less Than",
      LessThanOrEqualTo: "Less than or Equal to",
      Include: "Include",
      Excluding: "Excluding",
      FilterSubSegment: "Temp sub group list",
    },
    uploadGroup: {
      title1: "Data Analysis",
      title2: "Upload",
      title3: "Count",
      title4: "Audience Id Gen. Rule",
      title5: "Automatic Generate",
      title6: "Manually Generate",
      title7: "Audience ID",
      title8: "Enter Audience ID",
      title9: "Name",
      title10: "Audience Name",
      title11: "Audience sql",
      title12: "Enter Audience sql",
      title13: "Select Gen. Rule",
    },
    userGroupList: {
      audience: "Audience",
      audienceList: "Audience Management",
      groupName: "Group Name",
      pleaseEnterGroupName: "Enter Group Name",
      groupType: "Type",
      pleaseSelectGroupType: "Select Type",
      regularAudience: "Label Selected Audience",
      uploadAudience: "Upload Audience",
      customAudience: "Customized Audience",
      creator: "Created by",
      pleaseEnterCreatorName: "Enter Creator Name",
      search: "Search",
      clickOnThePopulationName: "Click Population Name",
      viewAudienceRules: "View Rules",
      createAudience: "Create Audience",
      audienceID: "Audience ID",
      audienceName: "Name",
      numberOfUsers: "Count",
      creationTime: "Created at",
      calculationType: "Calculation Type",
      lastCalculationTime: "Recent Calculation Time",
      status: "Status",
      operation: "Operation",
      disable: "Disable",
      enable: "Enable",
      copy: "Copy",
      edit: "Edit",
      analysis: "Analysis",
      delete: "Delete",
      theAudienceIsNotDelete: "Population in Use/Disabled!",
      theAudienceIsNotAllowDelete: "Population in Use/Disabled!",
      deleteTheAudienceConfirm: "Confirm Delete Audience?",
      confirm: "Confirm",
      cancel: "Cancel",
      cancelDeleteOpration: "Cancel Delete!",
      thisAudience: "This Audience",
      ToBeExecuted: "To Be Executed",
      InProgress: "In Progress",
      Success: "Success",
      Failed: "Failed",
      UserDeleteAdministrators: "User deletes visible to administrators",
      Delete: "Delete",
      disableThisAudienceConfirm: "Confirm disable this audience?",
      enableThisAudienceConfirm: "Confirm enable this audience?",
      
      disableThisUseCaseConfirm: "Confirm disable this UseCase?",
      enableThisUseCaseConfirm: "Confirm enable this UseCase?",
      disableThisAudienceCancel: "Cancel disable!",
      enableThisAudienceCancel: "Cancel enable!",
      addItemGroup: "New group sub",
    },
    userItemGroupList: {
      audienceList: "Sub Audience List",
      groupName: "Sub Group Name",
      pleaseEnterGroupName: "Enter Group Name",
      groupType: "Type",
      pleaseSelectGroupType: "Select Type",

      creator: "Created by",
      pleaseEnterCreatorName: "Enter Creator Name",
      search: "Search",
      clickOnThePopulationName: "Click Population Name",
      audienceMainID: "Main Audience ID",
      audienceID: "Sub Audience ID",
      audienceName: "Sub Audience Name",
      numberOfUsers: "Count",
      creationTime: "Created at",
      calculationType: "Calculation Type",
      lastCalculationTime: "Recent Calculation Time",
      status: "Status",
      operation: "Operation",
      disable: "Disable",
      enable: "Enable",
      copy: "Copy",
      edit: "Edit",
      analysis: "Analysis",
      delete: "Delete",
      theAudienceIsNotDelete: "Population in Use/Disabled!",
      theAudienceIsNotAllowDelete: "Population in Use/Disabled!",
      deleteTheAudienceConfirm: "Confirm Delete Audience?",
      confirm: "Confirm",
      cancel: "Cancel",
      cancelDeleteOpration: "Cancel Delete!",
      thisAudience: "This Audience",
      ToBeExecuted: "To Be Executed",
      InProgress: "In Progress",
      Success: "Success",
      Failed: "Failed",
      UserDeleteAdministrators: "User deletes visible to administrators",
      Delete: "Delete",
      addItemGroup: "New group sub",
    },
    userGroupDetail: {
      audienceRules: "Audience rules",
      filterExploration: "Filter exploration",
      goBack: "GoBack",
      totalNumberOfPeople: "Total number of people",
      people: "people",
    },
    userAnalysis: {
      all: "All",
      audienceDashboard: "Audience Dashboard",
      membershipAttributes: "Memb. Attributes",
      consumptionBehaviorPreferenceAttr: "Pref. Behav. Attribute",
      consumptionBehaviorDataAttr: "Behav. Data Attribute",
      selectAudience: "Select",
      totalMembershipCount: "Total Memb. Count",
      membershipClassification: "Memb. Classif.",
      regularMembers: "Reg. Members",
      OHMembers: "OMM member",
      breakfastCardMembers: "Breakfast Mem.",
      McCafeMembers: "McCafe Member",
      membershipStatus: "Memb. Status",
      registrationChannel: "Reg. Channel",
      numberOfPeople: "Count",
      Proportion: "active Users by Channel/Proportion",
      City: "Common Market&City",
      PurchasePeriod: "Preferred Purchase Time",
      Ingredients: "Top Purchased Prod.-Ingredients",
      Taste: "Top Purchased Prod.-Taste",
      CookingMethod: "Top Purchased Prod.-Cooking Method",
      CityRanking: "City Ranking",
      Cycle: "Cycle",
      TimePoint: "Time",
      DaysSinceLastOrder: "Days Since Last Order",
      FreqStats: "Freq. Stats",
      AvgDaysperPerson: "Avg. Days per Person",
      AvgFreqperPerson: "Avg. Freq. per Person",
      Times: "Times",
      Days: "Days",
    },
    pushStrategy: {
      precisionCommunication: "Precision communication",
      behaviorManagement: "Behavior management",
      add: "add",
      confirm: "confirm",
      pleaseAddBehavior: "Please add behavior/action",
      confirmDeletion: "Confirm deletion",
      cancel: "cancel",
      createBehavior: "Add Action",
      behaviorSelection: "Select Action",
      intelligentOrNot: "whether it is intelligent",
      intelligentMode: "Intelligent Mode",
      unintelligent: "unintelligent",
      yes: "Yes",
      no: "No",
      nextStep: "Next",
      stuffCouponCoupon: "stuff coupon/cram coupon",
      onlyProcess: "only process/handle",
      reminderSettings: "Reminder settings",
      pushTemplateSelection: "Content Type",
      smartCopywriting: "Smart Content",
      customizedCopy: "Customized Content",
      copywritingPushRule: "Content push rule",
      sequentialOrder: "sequential principle/order",
      randomPrinciple: "random principle",
      eventPrinciple: "event principle",
      smartPreferencePrinciple: "smart preference principle",
      pushMessage: "Select Content",
      chooseText: "Choose Content",
      dateEvent: "date/event",
      actionEvents: "action/events",
      workingDay: "working day",
      weekend: "weekend",
      holiday: "holiday",
      reminderTime: "Reach Time",
      intelligentTime: "Intelligent time",
      fixedTime: "Fixed time",
      pushTimeOnlyTwoHours:
        "Push time for the current day must be at least 2 hours later than the current time; otherwise, it cann't be pushed today.",
      reminderStartAndEndDate: "reminder start and end date",
      crowdDataTime: "crowd data time",
      saveAndAddAction: "Save and add action",
      pleaseSelectTime: "Select",
      handleActionSettings: "handle action settings",
      pleaseSelectChannel: "please select channel",
      time: "Time",
      stuffCouponSetting: "stuff coupon setting",
      periodicDelivery: "Reach Cycle",
      couponName: "coupon name",
      pleaseSelect: "Please select",
      save: "save",
      pleaseSelectAction: "please select behavior/action",
      pleaseSelectIntelligentOrNot: "please choose whether it is intelligent",
      cannotBeEmpty: "cannot be empty",
      reminder: "reminder",
      smartReminder: "smart reminder",
      intelligentDataProcessing: "intelligent data processing",
      intelligentStuffCoupon: "intelligent stuff coupon",
      immediatePush: "Immediate",
    },
    userManagement: {
      title1: "Settings",
      title2: "User Management",
      title3: "User List",
      pageTitle: "User Management",
      tableTitle: "UserID",
      tableTitle1: "Nickname",
      tableTitle2: "User Role",
      tableTitle3: "Email",
      tableTitle4: "Created by",
      tableTitle5: "Created at",
      tableTitle6: "Updated by",
      tableTitle7: "Updated at",
      tableAction: "Operation",
      addUserBttn: "Add New User",
      addUserTitle: "Add New User",
      addUserTitle1: "Cancel",
      addUserTitle2: "Save",
      addUserTitle3: "Nickname",
      addUserTitle4: "Enter Nickname",
      addUserTitle5: "Password",
      addUserTitle6: "Enter Password",
      addUserTitle7: "Auto-generated",
      addUserTitle8: "Manual Input",
      addUserTitle9: "Email",
      addUserTitle10: "Enter Email Address",
      addUserTitle11: "User Role",
      addUserTitle12: "Select User Role",
      addUserMsg1: "Email Can't Be Empty!",
      addUserMsg2: "Email Can't Be Empty!",
      addUserMsg3: "Select User Role!",
      addUserMsg4: "Password Required!",
      addUserMsg5: "Email is not valid",
      addUserMsg6: "Email is valid",
      searchMsg1: "Enter UserID",
      searchMsg2: "Enter User Email Address",
      searchTitle1: "User Email",
      searchBtn1: "Search",
      searchSucMsg: "Query Success! ",
      searchFailMsg: "Query Failed! ",
      editUserTitle: "Edit User",
      userMgtMsg1: "New User Added Successfully!",
      userMgtMsg2: "Failed to Retrieve Role!",
      userMgtMsg3: "Update Successfully！",
      //popup
      popupTitle1: "Confirm enable this user？",
      popupTitle2: "After enabling, this user will have corresponding permissions.",
      popupTitle3: "Enable",
      popupTitle4: "Confirm disable this user？",
      popupTitle5: "After disabling, this user will be prohibited from logging in.",
      popupTitle6: "Disable",
      popupTitle7: "User enabled successfully.",
      popupTitle8: "User disabled successfully.",

      emailExistsTitle: "Email already exists",
      emailExistsContent:'This email already exists. Do you want to add it to the current subscription?',
      bindRole: "Bind Role",

    },
    accountDashboard:{
      title1: "Account Dashboard",
      title2: "info",
      title3: "Consumed",
      title4: "Remaining",
      title5: "Usage Rate",
    },
    logData: {
      title1: "Settings",
      title2: "Login log",
      tableTitle1: "Login Status",
      tableTitle2: "Login Details",
      tableTitle3: "Login User",
      tableTitle4: "Login Time",
    },
    systemManagement: {
      title1: "Settings",
      title2: "Role Management",
      pageTitle: "Role Management",
      tabTitle1: "Role Management",
      tabTitle2: "Button Management",
      tabTitle3: "Menu",
      searchBtn: "Search",
      //Role Mgt table
      roleId:'Role ID',
      roleMgtBtn: "Add Role",
      roleMgtTitle: "Role List",
      roleMgtTitle1: "Role Name",
      roleMgtTitle2: "Is Admin",
      roleMgtTitle3: "Role Description",
      roleMgtTitle4: "Created at",
      roleMgtTitle5: "Operation",
      roleMgtTitle6: "Created by",
      roleSearchMsg: "Enter Role Name",
      roleAddTitle: "Add Role",
      roleAddTitle1: "Cancel",
      roleAddTitle2: "Save",
      roleAddTitle3: "Page Resource Menu",
      roleAddTitle4: "Admin",
      roleAddTitle5: "Yes",
      roleAddTitle6: "No",
      roleAddTitle7: "Enter Desc Info",
      roleAddMsg1: "Role Name Can't Be Empty",
      roleEditTitle: "Edit Role",
      //btn mgt table
      btnMgtTitle: "Button Management",
      btnDetailTitle: "Operation Details",
      btnMgtTitle1: "Allocate Button Permissions",
      btnMgtTitle2: "Button Menu",
      btnMgtTitle3: "Remarks",
      btnMgtTitle4: "Select Button Perms",
      btnMgtTitle5: "Allocation",
      //menu mgt table
      resSearchTitle: "Menu Name",
      resSearchMsg: "Enter Menu Name",
      resMgtTitle: "List",
      resMgtTitle1: "Icon",
      resMgtTitle2: "Address",
      resMgtTitle3: "Description",
      resMgtTitle4: "Updated at",
      resMgtTitle5: "Operation",
      resMgtTitle6: "Updated by",
      menuMgtTitle1: "Edit Resource Menu",
      menuMgtTitle2: "Menu (Secondary Menu Hidden)",
      menuMgtTitle3: "Enter Desc Info",
      // message
      sysMgtMsg1: "Operation Succ.!",
      sysMgtMsg2: "Deleted Role Successfully!",
      sysMgtMsg3: "Submitted for Review Successful!",
      sysMgtMsg4: "Successfully Modified!",
      sysMgtMsg5: "Modification Failed!",
      ConfirmDeleteRole: "Confirm Delete Role？",
      saveWhitelist: "Are you sure you want to save the whitelist?",
      saveBlacklist: "Are you sure you want to save the blacklist?",
      canceled: "Canceled！",
    },
    txtManagement: {
      title1: "Use Case",
      title2: "Content Management",
      tableTitle1: "Content ID",
      tableTitle2: "Content Title",
      tableTitle3: "Channel",
      tableTitle4: "Content",
      tableTitle5: "Created by",
      tableTitle6: "Created at",
      tableTitle8: "Status",
      tableTitle7: "Operation",
      txtSearchDefault: "Content ID/Content Name/Content Channel",
      labelBtn: "Content Label",
      addBtn: "Create New Template",
      editBtn:  "Edit Template",
      lableTitle: "Content Tag Management",
      lableSideTitle: "Content Label Display",
      lableTitle1: "Label Details",
      lableTitle2: "Create",
      lableTitle3: "Edit",
      lableTitle4: "Delete",
      lableTitle5: "Confirm Deletion?",
      lableEditTitle: "Edit Label",
      lableEditTitle1: "Confirm & Save",
      lableEditTitle2: "Label Identifier",
      lableEditTitle3: "Label Name",
      lableEditTitle4: "Enter Label Name",
      lableEditTitle5: "Parent Group",
      lableEditTitle6: "Select Parent Group",
      lableEditTitle7: "Enable or Disable",
      lableEditTitle8: "Enable",
      lableEditTitle9: "Disabled",
      lableAddTitle: "Add Label",
      lableMsg1: "Enter Label Identifier",
      lableMsg2: "Fill Label Name",
      lableMsg3: "Select Enable/Disable",
      AddFormTitle1: "Create New",
      AddFormTitle2: "Smart Coupon Placeholder",
      AddFormTitle3: "Content Channel：",
      AddFormTitle4: "Push Channels",
      AddFormTitle5: "Choose channel",
      AddFormTitle6: "Content Name：",
      AddFormTitle7: "Tag",
      AddFormTitle8: "Select Available Tags",
      AddFormTitle9: "Content Title",
      AddFormTitle10: "Already Entered ",
      AddFormTitle11: " Character",
      AddFormTitle12: "Redirect Link",
      AddFormTitle13: "Content Target Name",
      AddFormTitle14: "Delivery ID",
      AddFormTitle15: "Save and Apply",
      AddFormTitle16: "Content",
      AddFormTitle17: "Edit Content",
      AddFormTitle18: "Confirm",
      txtMgtMsg1: "Delete Content?",
      txtMgtMsg2: "Delete Content Permanently",
      txtMgtMsg3: "Deletion Successful!",
      txtMgtMsg4: "Cancel Delete Operation!",
      txtMgtMsg5: "Create success",
      messageAddedSuc: "New message added successfully！",
      reasonTitle: "Failure Reason",
      createPush:'Create Content',
      sms: "SMS",
      email: "Email",
      userPlace:'User Placeholder',
      couponPlace:'Coupon Placeholder',
      content:'Content',
      subject:'Subject',
    },
    strategyManagement: {
      // 修改部分
      title1: "Precise comm.",
      title2: "Use Case Management",
      title3: "Use Case Management List",
      title4: "Global Control",
      globalTitle1: "Global Freq. Limit",
      globalTitle2: "Control Group Lock Time",
      globalTitle3: "B/W List Management",
      globalTitle4: "Filter Management",
      globalTitle5: "Use Case Group Management",
      globalTitle6: "Customized Deduplication Management",
      globalTitle7: "Filter Time Control",
      globalTitle8: "Task Reminder Management",
      tabTitle1: "Use Case",
      tabTitle2: "Indicator Parameter",
      buttonTitle1: "Confirm Adjustment",
      buttonTitle2: "Adjust Priority",
      buttonTitle3: "Priority Sort",
      buttonTitle4: "Search",
      // 修改部分
      strategyLabel1: "Use Case ID",
      strategyLabel2: " Use Case Name",
      strategyLabel3: "Delivery Time",
      strategyPlaceholder1: "Enter use case ID",
      strategyPlaceholder2: "Enter use case name",
      strategyTableTitle1: "Priority Sort",
      strategyTableTitle2: "Periodic",
      strategyTableTitle3: "Start Time",
      strategyTableTitle4: "End Time",
      strategyTableTitle5: "Sort Option",
      strategyTableTitle6: "Use Case Freq. Control",
      strategyTableTitle7: "Control Group Proportion",
      strategyTableTitle8: "Effective or Not",
      strategyTableTitle9: "Push Status",
      strategyTableTitle10: "Operation",
      operateTip1: "Use Case Details",
      operateTip2: "Edit use case",
      operateTip3: "Delete use case",
      operateTip4: "Confirm use case deletion?",
      globalTitle: "Global Freq. Limit",
      globalText: "Save",
      globalText1: "Every",
      globalText2: "Push Once",
      globalText3: "Cancel",
      controlText1: "Control Group Lock Time",
      BWlistTitle: "B/W List Management",
      BWlistFooter1: "Blacklist Management:",
      BWlistFooter2: "Whitelist Management:",
      BWlistFooter3: "Not Enabled",
      BWlistFooter4: "Enable",
      BWlistFooter5: "Filter",
      BWMTitle1: "Whitelist",
      BWMTitle2: "Blacklist",
      BWMPlaceholder: "Enter mid/Group Search",
      BWMBtn1: "Add New List",
      BWMBtn2: "Add Group",
      BWMTableCol1: "Serial Number",
      BWMTableCol2: "Type",
      BWMTableCol3: "Appropriate Use Case",
      BWMTableCol4: "Effective Date",
      BWMTableCol5: "Expiration Date",
      BWMTableCol6: "Group",
      BWMAddTitle: "Add New List",
      BWMAddText: "Type",
      BWMAddText2: "Date",
      BWMAddRules1: "Select mid",
      BWMAddRules2: "Select Group",
      BWMAddRules3: "Select use case",
      BWMAddRules4: "Select Date Range",
      BWMAddRules5: "Fill Group Name",
      BWMAddRules6: "Fill Group Description",
      BWMAddGroup1: "Group Name",
      BWMAddGroup2: "Group Description",
      BWMAddGroup3: "Add Group",
      BWMTplacholer1: `Enter MID (comma-separated for multiple additions)`,
      BWMTplacholer2: `Select All / Multiple Use Cases`, // 修改部分
      BWMEditTitle: "Editor List",
      BWMEditOk: "Confirm & Save",
      BWMEditText1: "Edit",
      BWMEditText2: "Delete",
      BWMEditText3: "Confirm Deletion?",
      BWMEditText4: "Confirm",
      filterTitle: "Filter Management",
      filterBtn1: "Rule Library",
      filterBtn2: "Create Rule",
      filterBtn3: "Create Group",
      filterCol1: "Name",
      filterCol2: "Content",
      filterCol3: "Description",
      filterCol4: "Update Time",
      filterCol5: "Modify Personnel",
      filterAddTitle1: "Filter Group(Create)",
      filterAddTitle2: "Filter Group(Modify)",
      filterAddText1: "Select Rule",
      filterAddRules1: "Enter Group Name",
      filterAddRules2: "Choose Rule",
      filterAddRules3: "Enter Description",
      filterRuleTitle1: "Create Rule",
      filterRuleTitle2: "Modify Rule",
      filterRuleCol1: "Value",
      filterRuleCol2: "Select Source",
      filterResource1: "Historical Control Days",
      filterResource2: "Global Control Days",
      filterResource3: "Audience List",
      filterRuleCol3: "Control Range",
      filterRuleCol4: "Select Audience",
      filterRuleText2: "day",
      filterRule1: "Enter Rule Name!",
      filterRule2: "Enter Rule Info value!",
      filterRule3: "Select Source!",
      filterRule4: "Enter Control Range!",
      filterRule5: "Select!",
      deletePop: "Confirm Deletion?",
      filterRule8: "Rule Name",
      filterRule6: "Explanation",
      classificationTitle: "Use Case Group Management",
      classificationTitle1: "Classif. display",
      classificationTitle2: "Category details",
      classificationBtn1: "Add new category",
      classfiDeleteTip:
        "Deletion will cause abnormal display of use case categories that have selected.",
      classfiDeleteok: "Confirm deletion",
      classfiTableCol1: "Type identifier",
      classfiTableCol2: "Type name",
      classfiTableCol3: "Parent Group",
      classfiAddTitle: "Add new category",
      classfiEditTitle: "Edit classif.",
      classTablecol1: "Parent categories",
      classTablecol2: "Select Parent Group ID",
      classTablecol3: "Classification ID",
      classTablecol4: "Classif. name",
      classRules1: "ID Can't Be Empty！",
      classRules2: "Category name Can't Be Empty！",
      deduplicationTitle: "Customized Deduplication Management",
      timeControlTitle: "Filter Time Control",
      timeControlOk: "Confirm Filter Time",
      timeControlCancle: "Cancel Setting",
      timeControlTable: "Enable Filter Time:",
      Daily: "Daily",
      timeControlText: "Default to Current Time, Blank for No Scheduled Filter",
      WeChatTitle: "WeChat Warning Config",
      dupCreatenewgroup: "Create New Group",
      dupSearchbyname: "Search by Group Name",
      creator: "Created by",
      nameClassification: "Use Case Name/Classification",
      nameClassificationSearch: "Enter use case Name/Classification to Search",
      Priority: "Priority",
      StrategyClassification: "Use Case Classification", // 修改部分
      Group: "Group",
      Save: "Save",
      EditGroups: "Edit Groups",
      inputNameSearch: "Input Group Name to Search",
      Newrobot: "New Robot",
      Robotnumber: "Robot Number",
      EnterRobotNumber: "Enter Robot Number",
      WeChatname: "WeChat Name",
      enterWeChatname: "Enter WeChat Name",
      Whetherenable: "Enable or Disable",
      selectwhetherenable: "Select Enable/Disable",
      Editrobot: "Edit Robot",
      Groupname: "Group Name",
      status: "Status",
      Newtemplate: "New Template",
      Mode: "Mode",
      selIndicator: "Select Metrics",
      Indicatorselection: "Indicator Selection",
      Addfilteringmodule: "Add",
      addOrconditions: 'Add "OR"',
      addAndconditions: 'Add "AND"',
      Selectlabel: "Select",
      Selectcalculationrule: "Select Calculation Rule",
      fillcompletely: "Complete the Form",
      fillvalue: "Fill in the Value",
      templateinfo: "Template Information",
      Savestrategy: "Save use case", // 修改部分
      Next: "Next",
      Close: "Close",
      StartActivationStatus: "Use Case Enabled", // 修改部分
      Yes: "Yes",
      No: "No",
      Enterornotruleengine: "Enter or not rule engine",
      EnterFilteringProcess: "Enter Filtering Process?",
      Selectfilterrule: "Select filter rule",
      CustomizedDeduplication: "Customized Deduplication",
      CtrlGroup: "Reserve Ctrl Group",
      PeriodicDelivery: "Reach Cycle",
      Singletime: "Single time",
      WorkDay: "Work Day",
      Weekend: "Weekend",
      Cycle: "Cycle",
      PushSameDay: "Push Same Day",
      Validityperiod: "Validity period",
      startDate: "Start Date(inclusive)",
      endDate: "End Date(inclusive)",
      DefaultGregdate: "Default Greg. date",
      Frequency: "Frequency",
      Perday: "Per day",
      Everyweek: "Every week",
      Permonth: "Per month",
      Everyworkday: "Every workday",
      Everyweekend: "Every weekend",
      days: "days",
      RepeatInterval: "Repeat Interval(C)",
      weekslater: "weeks later",
      WeekByWeek: "Week by Week",
      monthonthe: "month on the",
      thday: "th day",
      TargetAud: "Audience",
      PriorityLevelTargetAud: "Priority Level - Audience",
      TrafficDistributionEntry: "Traffic Distribution Entry",
      IntelligentTrafficDistribution: "Intelligent Traffic Distribution",
      Tips: "Tips",
      Previous: "Previous",
      FillinName: "Fill in Name",
      FillinDescription: "Fill in Description",
      ModeSelection: "Mode Selection",
      SelectMode: "Select Mode",
      DataControl: "Data Control",
      SelectApplicableStrategy: "Select applicable use case", // 修改部分
      SelectDataControl: "Select Data Control",
      ConfirmPrioritySorting: "Confirm priority sorting?",
      DailyPush: "Daily Push",
      AlreadyPushed: "Already Pushed",
      NotPushed: "Not Pushed",
      CurrentStatusStrategy: "Current status of use case indicators.", // 修改部分
      FrequencyLimitationCannotBeEmpty: "Frequency Limitation cannot be empty.",
      FilterRuleCreatedSuccessfully: "Filter Rule Created Successfully！",
      SavedFilterRules: "Saved Filter Rules！",
      FailedToCreateFilterRule: "Failed to Create Filter Rule！",
      SelectImportanceLevel: "Select Importance Level！",
      SelectCategory: "Select Category！",
      StrategyDeliveryInfo: "Use Case delivery info", // 修改部分
      StrategyIDRange: "Use Case ID Range", // 修改部分
      SingleDelivery: "Single Delivery",
      IndicatorParameterStatus: "Indicator Parameter Status",
      SelectTargetAudience: "Select Target Audience！",
      ChooseAudienceFiltering: "Choose Audience Filtering！",
      StrategyValidityPeriodEmpty: "Use Case Validity Period Empty！", // 修改部分
      customizedOnlyOne:
        "Tips：Customized filters （ Interval Day Filtering Rule ）Choose Only One！",
      adjustThePriority: "Are you sure you want to adjust the priority？",
      DateCannotBeEmpty: "Date cannot be empty!",
      CategoryDeletedSuccessfully: "Category deleted successfully",
      CategoryDeletedException: "Category deleted exception",
      CategoryAddSuccessfully: "Category add successfully",
      CategoryAddException: "Category add exception",

      UploadAvatarSuccessfully: "Upload avatar successfully",
      CategoryEditSuccessfully: "Category edit successfully",
      CategoryEditException: "Category edit exception",
      AddFilteringModule: "Add!",
      timeZoneWarning:'You must select a future date',

    },
    couponManagement: {
      title1: "Coupon Management",
      title2: "Coupon List",
      tableTitle1: "Coupon Number",
      tableTitle2: "Name",
      tableTitle3: "Coupon Name",
      tableTitle4: "Coupon ID",
      tableTitle5: "Smart Coupon Name",
      tableTitle6: "Created at",
      editFormTitle: "Modify Coupon",
      editFormTitle1: "Tag",
      couponMgtMsg1: "No Changes Made",
      couponMgtMsg2: "Parameter Cannot Be Empty",
      couponMgtMsg3: "Do you want to delete this coupon?",
      couponMgtMsg5: "This coupon has been selected by the behavior.",
      couponMgtMsg4: "Cancel Delete!",
      title3: "Confirm",
      title4: "Cancel",
      searchDefault: "Name/Coupon ID/Region Restriction",
      couponMgtBtn1: "Coupon Tag",
      couponMgtBtn2: "Create New Coupon",
      couponTagTitle: "Coupon Tag Management",
      couponTagTitle1: "Tag Details",
      couponTagTitle2: "Create",
      couponTagTitle3: "Edit",
      couponTagTitle4: "Delete",
      couponTagTitle5: "Confirm Deletion?",
      couponTagSideTitle: "Coupon Tag Display",
    },
    DataSetTagManagement: {
      title1: "Label",
      title2: "Label Management",
      title3: "Submission Record",
      tagTabTitle1: "Label ID",
      tagTabTitle2: "Label",
      tagTabTitle3: "Created at",
      tagTabTitle4: "Updated at",
      tagTabTitle5: "Label Trigger Rate",
      tagTabTitle6: "Disable/Enable",
      recdTabTitle1: "User",
      recdTabTitle2: "Submission Time",
      recdTabTitle3: "Function",
      recdTabTitle4: "Operation Details",
      recdTabTitle5: "Operation Notes",
      //popup
      popupTitle1: "Confirm enable this label？",
      popupTitle2:
        "Enabling it will grant other users the permission to access this tag?",
      popupTitle3: "Enable",
      popupTitle4: "Confirm disable this label？",
      popupTitle5:
        "Disabling it will revoke the permission of other users to access this tag",
      popupTitle6: "Disable",
    },
    strategyStore: {
      // 修改部分
      contactType: "Contact type",
      SelectCrowdStatus: "Select crowd status",
      StaticAudience: "Static Audience",
      DynamicCustGroup: "Dynamic cust. group",
      preciseComm: "Precise comm.",
      strategyLibrary: "Use Case library", // 修改部分
      regularStrategy: "Regular",
      strategyDetails: "Use Case Details", // 修改部分
      editStrategy: "Edit",
      businessPurpose: "Business Objective",
      crowdDefinition: "Definition",
      priority: "Priority",
      commCycle: "Communication Frequency",
      controlGroupProportion: "Control Group Proportion",
      lockinPeriod: "Lock-in Period",
      strategy: "use case", // 修改部分
      strategyCategoryManagement: "Use Case Group Management", // 修改部分
      saveStrategy: "Save use case", // 修改部分
      strategyID: "use case ID", // 修改部分
      strategyName: "Use Case Name", // 修改部分
      strategyClassification: "Use Case Classification", // 修改部分
      periodicdelivery: "Reach Cycle",
      timezone: "Time Zone",
      repeat:'Repeat',
      on:'On',
      singleTime: "Single time",
      workDay: "Work Day",
      weekend: "Weekend",
      cycle: "Cycle",
      selectFrequency: "Select Frequency",
      validityPeriod: "Validity period",
      enterOrNot: "Enter or not",
      filteringRuleSelect: "Filtering Rule Select",
      defaultFilterRule: "Default Filter Rule",
      viewChangeFilters: "View/change filters",
      customizedFilters: "Customized filters",
      controlCreateRule:
        "New filter rule? Go to global control-create filter rules",
      selectCustomizedFilteringRules: "Select Customized Filtering Rules",
      selectChoose: "Select/Choose",
      defaultGregDate: "Default Greg. date",
      frequency: "Frequency",
      perDay: "Per day",
      everyWeek: "Every week",
      perMonth: "Per month",
      every: "Every ",
      everyWeekend: "Every weekend",
      thDay: "th day",
      days: "days",
      repeatInterval: "Repeat Interval",
      weeksLater: " weeks later",
      monthOnThe: "month on the ",
      targetAud: "Audience",
      priorityLevelTargetAud: "Priority Level - Audience",
      remarkTopPriority: "Remarks：Top priority 1",
      reserveCtrlGroup: "Reserve Ctrl Group",
      numberProportion: "Number Proportion",
      numberControl: "Number control",
      fixedQuantityAfterDedup: "Fixed quantity after dedup.",
      selectionResultsBased: "Selection Results Based",
      minNumberAfterDeduplication: "Min. Number after Deduplication",
      maxQtyAfterDedup: "Max. Qty After Dedup.",
      specialOccasion: "Special occasion",
      strategyInformation: "Use Case Information", // 修改部分
      strategyIDGenerate: "Use Case ID Generate", // 修改部分
      strategyImplement: "Use Case implement.", // 修改部分
      stratExecName: "Use Case Exec. Name", // 修改部分
      enterExecName: "Enter exec. name",
      strategyImplementID: "Use Case implement. ID", // 修改部分
      enterStrategyImplementID: "Enter use case implement. ID", // 修改部分
      pleaseEnterID: "Please Enter ID",
      pleaseEnterName: "Please Enter Name",
      pleaseEnterContent: "Please Enter Content",

      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      dedupFilter: "Dedup. filter",
      histControlFilters: "Hist. control filters",
      globalIntervalFilter: "Global Interval Filter",
      globalControlFilters: "Global control filters",
      lifecycleBasedStrategy: "Lifecycle-based Use Case", // 修改部分
      TimeScenarioStrat: "Time/scenario use case.", // 修改部分
      regionBasedStrat: "Region-based use case.", // 修改部分
      coopWithMarketing: "Coop with marketing",
      marketingBasedStrat: "Marketing-based use case.", // 修改部分
      channelBasedStrat: "Channel-based use case.", // 修改部分
      behaviorBasedStrat: "Behavior-Based Use Case.", // 修改部分
      eventBasedStrategy: "Event-based Use Case", // 修改部分
      activateOrderCust: "Activate 1st-order cust.",
      stimuNextOrder: "Stimu. next order",
      orderUplift: "order uplift for frequency decrease users",
      recallCustomerLoss: "Recall Customer Loss",
      breakfastScene: "Breakfast scene",
      nightSnakeScene: "night snake Scene",
      singlePersonStimul: "Single-person stimul.",
      multiPersonStimul: "Multi-person stimul.",
      familyScene: "Family Scene",
      lowTierCities: "Low-tier Cities",
      supportWeakStores: "Support new stores",
      remindMemberActivityBrowsing: "Remind Member Activity Browsing",
      remindAddToCart: "Remind add-to-cart",
      remindNewProdClicks: "Remind new prod. clicks",
      remindNewProd: "Remind new prod.",
      supportHighCompStores: "Support High Comp. Stores",
      publicDomainToOwnPlatform:
        "Conversion from Public Domain to Own Platform",
      takeawayToPlatformConv: "Takeaway to Platform Conv.",
      takeawayToDineConv: "Takeaway to Dine-in Conv.",
      dineConvToTakeaway: "Dine-in Conv. to Takeaway",
      coordinatingWithMemberCampaign: "coordinating with member campaign",
      rainStimul: "Rain stimul.",
      hyperthermiaStimul: "Hyperthermia stimul.",
      cityRebound: "City rebound",
      supportForNewStores: "Support for New Stores",
      cooperateWithProdPromo: "Cooperate with Prod. Promo",
      coopWithNewProd: "Coop with new prod.",
      epidemicRecovery: "Epidemic recovery",
      remindNextOrder:
        "Combine with life cycle，remind Next Order After Add-to-cart，Inc. consumer freq.",
      reminderByTime: "Reminders by time/scen.，Inc. user participation",
      targetCommunSupport: "For key regions/stores，Targeted commun. support",
      communWithMarket: "Communicate with Marketing，Max. effect of marketing",
      cultivateUserHabit:
        "Channel conv.，Cultivate Multi-Chan. Habits，Cultivate user habits",
      afterUserOnline:
        "After user online interactive behavior，2ndary commun.，Inc. conversion rate",
      predictAndComunicate:
        "Predict and Communicate for Specific Times, such as COVID",
      selectFilterRule: "Select filter rule",
      pleaseSelectCustomizedFilteringRules:
        "Please Select Customized Filtering Rules ",
      pleaseEnterStrategyID: "Please Enter strategy ID",
      enterStrategyName: "Enter strategy name",
      validityPeriodOfDelivery: "Validity Period of Delivery",
      selectStartDate:'Select Start Date',
      selectEndDate:'Select End Date',
      selectedTimezone: "Select Timezone",
      selectRepeat: "Select Repeat",
      selectOne: "Select One",
      selectStratCategory: "Select Strat. Category",
      pleaseSelectRuleEngine: "Please select rule engine",
      periodicDeliverySelect: "Reach Cycle Select",
      incFrequencyActivity: "Inc. frequency xx Activity",
      incFrequency: "Inc. frequency",
      deliveryAud: "Delivery Aud.",
      saveEvents: "Save events",

      recallCustomerLossActivity: "Recall Customer Loss xx Activity",
      recallCustomerLossBBQBIC: "Recall Customer Loss BBQBIC",
      lostRecallMidAut: "Lost recall Mid-Aut.",
      recallCustomerLossBA: "Recall Customer Loss BA",
      recallLongLossActivity: "Recall long-term loss xx Activity",
      recallLongTermLoss: "Recall long-term loss",
      lostRecall5th6thOrder: "Lost Recall 5th/6th Order",
      lostRecall4th5thOrder: "Lost Recall 4th/5th Order",
      lostRecall3th4thOrder: "Lost Recall 3th/4th Order",
      lostRecall2th3thOrder: "Lost Recall 2th/3th Order",
      lostRecall1th2thOrder: "Lost Recall 1th/2th Order",
      preventLostBrows: "Prevent lost brows.",
      preventLostByAddToCart: "Prevent lost by add-to-cart",
      preventCustLoss: "Prevent cust. loss",
      recallLongTermLossPay: "Recall long-term loss",
      recallLostBrowsAddToCart: "Recall lost brows. & add-to-cart",
      closeDurToEpidemicCity: "Closure due to Epidemic xx City…",
      closeDurToEpidemic: "Closure due to Epidemic",
      recallCustomerLossCity: "Recall Customer Loss xx City…",
      memberDayHappyMeal: "Member day happymeal",
      memberDayLostRecall: "Member Day Lost Recall",
      memberDay: "Member day",
      lostRecallDessert: "Lost recall dessert",
      recallCustomerLossRGM: "Recall Customer Loss RGM",
      recallCustomerLossSMS: "Recall Customer Loss SMS",
      breakfastCard: "Breakfast card",
      breakfastReminder: "Breakfast reminder",
      activateNewMembers: "Activate new members",
      activate: "Activate",
      applet: "Applet",
      onlyHandle: "Only Handle",
      preChurnTest: "pre-churn Test",
      freqInc1Order: "Freq. Inc. New Users 1 Order",
      freqInc2Orders: "Freq. Inc. New Users 2 Orders",
      freqInc3Orders: "Freq. Inc. New Users 3 Orders",
      freqInc4Orders: "Freq. Inc. New Users 4 Orders",
      freqInc5Orders: "Freq. Inc. New Users 5 Orders",
      freqInc: "Freq. Inc. New Users",
      activateFreq1Order: "Activate freq. 1 Order",
      activateFreq: "Activate freq.",
      test: "Test",
      periodicDeliveryFreq: "Reach Cycle Select 'Frequency' ！",
      selectDailyDeliv: "Select daily deliv.！",
      selectDelivDays: "Select deliv. days！",
      weeklyIntervalSelect: "Weekly Interval Select！",
      monthDaysForDelivery: "Month & Days for Delivery！",
      notbeEarlier:'End date cannot be earlier than start date'
    },
    resultDashboard: {
      title1: "Precise comm.",
      title2: "Effect Dashboard",
      title3: "Operational Overview",
      title4: "Analysis & Comparison",
      DataTabTitle1: "Select/Choose",
      DataTabTitle2: "Voucher Count",
      AnalyTabTitle1: "Data Indicator",
      AnalyTabTitle2: "Select Data Indicator",
      AnalyTabTitle3: "Strat 1",
      AnalyTabTitle4: "Select Add Use Case",
      AnalyTabTitle5: "Time Period",
      AnalyTabTitle6: "Start Analysis",
      AnalyTabTitle7: "Select Use Case 1",
      AnalyTabTitle8: "Select Time Period",
      strat: "Strat",
      SummaryStrategies: "Summary of strategies",
      TimeType: "Time type",
      TimeRange: "Time range",
      RegionRange: "Region range",
      PleaseSelectRegion: "Please select the region",
      ChannelScope: "Channel scope",
      SelectChannel: "Select Channel",
      ViewResults: "View results",
      TotalSalesRevenue: "Total sales revenue",
      PleaseSelectCustomerType: "Please select customer type",
      TotalNumberMembers: "Total number of members",
      NumberOrders: "Number of orders",
      NumberActiveMembers: "Number of active members",
      UserRetentionRate: "User retention rate",
      YearOnYearGrowthRate: "Year-on-year growth rate",
      likelyToChurn: "Likely to churn",
      NumberOfMembers: "Number of members",
      MonthOnMonthGrowthRate: "Month-on-Month Growth Rate",
      NumberNewMembers: "Number of new members",
      NumberHActiveMembers: "Number of highly active members",
      NumberMActiveMembers: "Number of moderately active members",
      NumberLActiveMembers: "Number of low active members",
      QueryException: "Query exception!",
      PleaseSelectCondition: "Please select at least one condition！",
      StrategyType: "Use Case Type",
      PleaseSelectStrategyType: "Please select use case type",
      CouponType: "Coupon type",
      PleaseSelectCouponType: "Please select coupon type",
      TotalSales: "Total sales",
      NumberRecipientsReached: "Number of recipients reached",
      StrategyMetrics: "Use Case metrics",
      ViewStrategyDetails: "View use case details",
      StrategyMetricDetails: "Use Case metric details",
      StrategySearch: "Use Case search",
      PleaseEnterContent: "Please enter content",
      StrategyName: "Use Case name",
      SalesRevenue: "Sales revenue",
      DiscountTheCoupon: "Discount of the coupon",
      CouponRedemptionRate: "Coupon redemption rate",
      OrderWithinPeriod: "Order rate within the validity period",
      PercentageIncreaseOrderRate: "Percentage increase in order rate",
      IncrementalSalesRevenue: "Incremental sales revenue",
      PercentageIncrementalSalesRevenue:
        "Percentage of incremental sales revenue",
      IncreaseSpendingPerson: "Increase in average spending per person",
    },
    strategyPushMgt: {
      DelivStrat: "Use Case Management",
      delivered: "Delivered",
      DeliveryStrategyList: "Delivery Use Case List",
      ExclDeleted: "（Excl. Deleted）",
      ToBeStarted: "Pending",
      Expired: "Expired",
      Stopped: "Stopped",
      AlreadyDeleted: "Deleted",
      strategyNameAudience: "Use Case ID/Use Case Name/Audience ID",
      AddDelivery: "Add Delivery",
      StartEndDate: "Start/End Date",
      BehaviorCount: "Action Count",
      DelivCycle: "Push Cycle",
      InProgressCount: "Audience Count",
      CompletedPeopleCount: "Completed People Count",
      Operation: "Operation",
      Details: "Details",
      DeliveryType: "Action Type",
      couponsCopywritingID: "Content ID",
      DelivTitle: "Content Title",
      PushTime: "Reach Time",
      PushDate: "Reach Date",
      DuplicateStrategy: "Duplicate Use Case",
      Restore: "Restore",
      ThoroughDeletion: "Thorough Deletion",
      IntelligentOptions: "Intelligent Options",
      SmartCoupons: "Smart Coupons",
      CustomizedCoupon: "Customized Coupon",
      SelectOptionPlese: "Select Option, Plese",
      product: "Products",
      EnableDisableStrategyExecution: "Enable/Disable Use Case Execution",
      setCrowdhistoricalControl:
        "set specific percentage of final crowd data and record into historical control group",
      saveToDefaultControlGroup: "If save to Default Control Group",
      productQuantity3510:
        "Optional - Select Multiple Sources for Product Data. Low/Medium/High Importance:  product quantity 3/5/10.",
      tips1:
        "Required - Choose one target for coupon scoring calculation. Profit Increase - Increase proportion of coupon revenue and coupon cost, decrease proportion of penalty items and coupon preference(1,4,2,3). Increase Order - Increase coupon preference, decrease penalty item ratio, coupon cost ratio, and coupon revenue ratio (1,1,3,5). Increase Sales Revenue - Increase coupon revenue ratio, decrease penalty items and coupon preference ratio, and coupon cost ratio (1,2,3,4).",
      tips2: "Optional - Exclude coupons with duplicate sending times.",
      DaysAfterDelimitingTheCrowd: "Days after delimiting the crowd",
      InProgress: "In Progress",
      AvoidCouponsPushed: "Avoid coupons that have been pushed.",
      stopSend: "Stop sending this coupon after {num} times",
      OptionalMsg1:
        "Non-mandatory option. Select the coupon setting for this use case to limit the number of people receiving the coupon. Multiple coupons can be selected for the audience limit.",
      OptionalMsg2:
        "Optional: In case a user does not match with any coupons or is limited by the quantity of coupons, guaranteed coupons will be provided. If multiple coupons are selected, the calculation will be based on the selected guaranteed coupon to determine the most suitable coupon for the customer.",
      OptionalMsg3:
        "Optional, Select the corresponding product to adjust its match with the user. Multiple products can be selected for adjustment. ",
      msg1: "Individuals who do not select guaranteed coupons, exceed the quantity limit, or do not match with any coupon will be filtered and removed.",
      msg2: "Optional exclusion of duplicate filtering with a specific set of strategies.",
      msg3: "The input value represents data that will not be processed by the intelligent algorithm. For example, entering 30% means that the remaining 70% will be used for algorithmic calculation.",
      Importance: "Importance",
      CoveredCategories: "Covered Categories",
      IncreaseSalesRevenue: "Increase Sales Revenue",
      IncreaseOrderVolume: "Increase Order Volume",
      IncreaseProfitability: "Increase Profitability",
      PrimaryTargets: "Primary Targets",
      OtherTargets: "Other Targets",
      SelectPrimaryTargets: "Select Primary Targets！",
      EnterOtherTargets: "Enter Other Targets & Frequency！",
      ProductPage: "Product Page",
      BatchImportting: "Batch Import......",
      ProductAdjustment: "Product Adjustment",
      ProductSelection: "Product Selection",
      CouponQuantityControl: "Coupon Quantity Control",
      CouponSelection: "Coupon Selection",
      BatchImport: "Batch Import",
      aaa: "张",
      MinimumDiscountCoupon: "Minimum Discount Coupon",
      DownloadTemplate: "Download Template",
      ProductID: "Product ID",
      ProductName: "Product Name",
      AdjustContent: "Adjust Content",
      ApplicationScope: "Application Scope",
      CouponName: "Coupon Name",
      QuantityControl: "Quantity Control",
      CouponNumber: "Coupon Number",
      CouponID: "Coupon ID",
      searchNameOrID: "Search Product Name/Product ID",
      EditContent: "Edit",
      FixedPosition: "Fixed Position",
      Promote: "Promote",
      Lower: "Lower",
      Exclude: "Exclude",
      UsageRange: "Usage Range",
      name1: "First place.",
      name2: "Second place.",
      name3: "Third place.",
      name4: "Fourth place.",
      name5: "Fifth place.",
      name6: "Sixth place.",
      name7: "Seventh place.",
      name8: "Eighth place.",
      name9: "Ninth place.",
      name10: "Tenth place.",
      nameNum1: "一名",
      nameNum2: "二名",
      nameNum3: "三名",
      nameNum4: "四名",
      nameNum5: "五名",
      SelectModifiedContent: "Select Modified Content！",
      SelectFixedPosition: "Select Fixed Position！",
      EnterPromotionInfo: "Enter Promotion Info！",
      FillDecreaseValue: "Fill Decrease Value！",
      SelectUsageRange: "Select Usage Range！",
      QueryCoupons: "Query Coupons",
      couponNameOrID: "Coupon Name Search/Coupon ID",
      Tips: "Tips",
      FillFrequencyControl: "Fill Frequency Control",
      EnterStrategyID: "Enter use case ID",
      selectRuleEngine: "Select rule engine",
      AlreadyCreated: "Already Created",
      NotCreated: "Not Created",
      EditCouponInsertion: "Edit Coupon Insertion",
      SaveCouponInsertion: "Save Coupon Insertion",
      IntelligentTime: "Intelligent Time",
      FixedTime: "Fixed Time",
      CouponStartEndTime: "Coupon Start/End Time",
      CrowdDataTime: "Crowd Data Time",
      EditReminder: "Edit Reminder",
      ViewReminder: "View Reminder",
      SaveReminder: "Save Reminder",
      SelectReminderChannel: "Select Reminder Channel",
      CopyMessageRule: "Content Rule",
      PushCopyMessage: "Push Content",
      ChooseText: "Choose Text",
      AlreadyFollowedOffAcc: "Already Followed Off. Acc.",
      NotFollowingOfficialAccount: "Not Following Official Account",
      AlreadyDownloadedApp: "Already Downloaded APP",
      NotDownloadedApp: "Not Downloaded APP",
      CouponSettings: "Coupon Settings",
      SaveAndNextStep: "Save and Next Step",
      SaveAddAction: "Save & Add Action",
      RestoreStrat: "Restore Strat.",
      IncludeBehavior: "Include Behavior",
      ExcludeBehaviors: "Exclude Behaviors",
      createStrategy: "Create Use Case",
      currentDay: "Same Day (T+0)",
      nextDay: "Next Day (T+1)",
    },
    StrategyGroup: {
      title1: "Settings",
      title2: "Task Management",
      title3: "Application",
      pushTabTitle1: "Today's ",
      pushTabTitle2: "Push Tasks",
      pushTabTitle3: "Download Deliv. Results",
      pushTabTitle4: "Push Date",
      pushTabTitle38: "Push Version",
      pushTabTitle39: "Algorithm synchronous mapping",
      pushTabTitle5: "Task Status",
      pushTabTitle6: "Tag Sync.",
      pushTabTitle7: "Data Preparation",
      pushTabTitle8: "Audience Filtering",
      pushTabTitle9: "Strat. Result Gen.",
      pushTabTitle10: "Audience Result Gen.",
      pushTabTitle11: "Result Data Upload",
      pushTabTitle12: "Verify Uploaded Data",
      pushTabTitle13: "Delivery Data",
      pushTabTitle14: "Successful Deliv.",
      pushTabTitle15: "Deliv. Result Validation",
      pushTabTitle16: "Manual Deliv.",
      pushTabTitle17: "Timed Deliv.",
      pushTabTitle18: "Not Started",
      pushTabTitle19: "In Progress",
      pushTabTitle20: "Completed",
      pushTabTitle21: "Failed",
      pushTabTitle22: "Blacklist synchronization.",
      pushTabTitle23: "Event synchronization.",
      pushTabTitle24: "Pure data synchronization.",
      pushTabTitle25: "Intelligent data preparation.",
      pushTabTitle26: "Intelligent data synchronization.",
      pushTabTitle27: "Algorithm task generation.",
      pushTabTitle28: "Intelligent algorithm calculation.",
      pushTabTitle29: "PER data feedback.",
      pushTabTitle30: "Whitelist feedback.",
      pushTabTitle31: "Control data feedback.",
      pushTabTitle32: "Pure data feedback.",
      pushTabTitle33: "Generation of intelligent use case results.",
      pushTabTitle34: "Generation of intelligent audience data.",
      pushTabTitle35: "Reset the process?",
      pushTabTitle36: "Operation Exception！",
      pushTabTitle37: "Monthly data update",
      timeTabTitle1: "Timed Deliv. Settings",
      timeTabTitle2: "Confirm Timed Deliv.",
      timeTabTitle3: "Cancel Timed Setting",
      timeTabTitle4: "Push Time",
      timeTabTitle5: "After Preceding Task Daily",
      timeTabTitle6:
        "Default to current time when filling in the time, not start timed push without time.",
      tabTitle1: "Recent 30-day Push Success Rate",
      tabTitle2: "Average Duration of Recent 30-day Push Data",
      tabTitle3: "Average Duration of Recent 30-day Push Result Validation",
      stratMsg1: "Failed to Verify Data Upload, Cannot Temp. Download!",
      stratMsg2: "Cur. Date Cannot Be Downloaded!",
      stratMsg3: "Failed to Verify Data Upload!",
      subTabTitle1: "Push Status",
      subTabTitle2: "Tag Sync. Completion Time",
      subTabTitle3: "Audience Filter Comp. Time",
      subTabTitle4: "Upload Comp. Time",
      subTabTitle5: "Deliv. Comp. Time",
      subTabTitle6: "Deliv. Verif. Comp. Time",
      confirmTabTitle1: "Confirm Delivery",
      confirmTabTitle2: "Data",
      confirmTabTitle3: "This result will be pushed to the result database.",
      confirmTabTitle4: "Delivery",
      stratMsg4: "Cancel Deliv. Operation!",
      Jan: "Jan",
      Feb: "Feb",
      Mar: "Mar",
      Apr: "Apr",
      May: "May",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Aug",
      Sep: "Sep",
      Oct: "Oct",
      Nov: "Nov",
      Dec: "Dec",
      minute: "min",
      resetBtn: "Reset",
      status1: "Not Pushed",
      status2: "To Be Delivered",
      status3: "Delivering",
      status4: "Deliv. Comp. Time",
      status5: "Delivery Failed",
    },
    uploadPackage: {
      title1: "Data Analysis",
      title2: "Upload File",
      tabTitle1: "Data Type",
      tabTitle2: "Click to Choose File ",
      tabTitle3: "Upload",
      tabTitle4: "Mobile number",
      tabTitle5: "or Drag Your File Here",
      tabTitle6: "Please select the file you want to upload",
      tabTitle7: "You have uploaded {number} of ",
      tabTitle8: "Mobile number",
      tabTitle9: "Email",
      tabTitle10:
        "Note: Only Excel and CSV format files can be uploaded. Uploading mobile phone numbers, member IDs, UnionIDs, and email addresses is supported.",
      tabTitle11: "Excel Template",
      tabTitle12: "CSV File Template",
      tabTitle13: "Template File",
      tabTitle14: "Please select the data type!",
    },
    MaterialTagMgmt: {
      title1: "Content Management",
      title2: "Label Management",
      title3: "Label List",
      title4: "Create Label",
      tabTitle1: "Label name",
      tabTitle2: "Label description",
      tabTitle3: "Label Structure",
      tabTitle4: "Update Time",
      tabTitle5: "Usage count",
      tabTitle6: "Popularity ranking",
      tabTitle7: "Operation",
      tabMsg1: "Please enter the label name to search",
      reset: "reset",
      createTagLevel: "create hierarchy",
      editTag: "Edit Label",
      tagLvTitle1: "Hierarchy",
      tagLvTitle2: "Please select a hierarchy",
      tagLvTitle3: "label values",
      tagLvTitle4: "Please enter label values",
      tagLvTitle5: "Description",
      tagLvTitle6: "Please enter the label description",
      tagLvTitle7: "Hierarchy name",
      tagLvTitle8: "Please enter the hierarchy name",
      tagLvTitle9: "Edit Hierarchy",
      editTagSuc: "Edit label success！",
      addTagSuc: "Add label success！",
      addLevelSuc: "Add level success！",
      editLevelSuc: "Edit level success！",
    },
    materialUpload: {
      MaterialMgmt: "Content Management",
      UploadMaterial: "Upload material",
      materialUpload: "Upload material",
      InformationEntry: "Information Entry",
      dropFileHere: "Drag and drop your file here",
      ChooseFileToUpload: "Choose file to upload",
      All: "All",
      MaterialName: "Material Name",
      PleaseEnterModification:
        "Please enter the desired name for modification.",
      Smart: "Smart",
      Custom: "Custom",
      Inheritance_material_file_name: "Inheritance_material_file_name",
      MaterialClassification: "Material classification",
      PleaseChooseCategory:
        "Please choose the category you would like to modify.",
      MaterialTags: "Material tags",
      PleaseSelectTags: "Please select the tags you would like to modify.",
      MaterialFormat: "Material format",
      PleaseSelect: "Please select.",
      ValidityPeriod: "Validity Period",
      to: "to",
      StartTime: "Start time",
      EndTime: "End time",
      LongTermValidity: "Long-term validity",
      BulkSave: "Bulk save",
      Upload: "Upload",
      UploadSuc: "Material uploaded successfully!",
      UploadCannotEmpty: "Upload file cannot be empty",
      selectMaterialFirst: "Please select the material first!",
    },
    materialLibrary: {
      MaterialMgmt: "Content Management",
      MaterialLibrary: "Material library",
      MaterialName: "Material Name",
      EntryMaterialName: "Entry Material Name",
      materialID: "Material ID",
      EntryMaterialID: "Entry Material ID",
      Reset: "Reset",
      ClassifDisplay: "Classif. display",
      PleaseSelectTag: "Select",
      PleaseSelectTheType: "Please select the material type",
      PleaseSelectStatus: "Please select the status",
      validity: "validity",
      All: "All",
      BatchEdit: "Batch edit",
      BatchDownload: "Batch download",
      BatchDelete: "Batch delete",
      ValidityPeriod: "Validity Period",
      downloadURL: "Download URL",
      Creator: "Created by",
      type: "Type",
      Format: "Format",
      CreationTime: "Created at",
      download: "Download",
      DownloadStatus: "Download status",
      ConfirmDelete: "Confirm delete?",
      EditMaterial: "Edit Material",
      MaterialDimensions: "Material dimensions",
      width: "Width",
      height: "Height",
      MaintainAspectRatio: "Maintain Aspect Ratio",
      Preview: "Preview",
      imageType: "Image type",
      PleaseSelectMaterials: "Please select materials！",
      ConfirmDeletingSelectedMaterials: "Confirm deleting selected materials?",
    },
    categoryMgt: {
      MaterialMgmt: "Content Management",
      CategoryManagement: "Category management",
      CategoryName: "Category name",
      PleaseEnterSearch: "Please enter the category name to search",
      ClassifDisplay: "Classif. display",
      CategoryList: "Category list",
      New: "New",
      avatar: "Photo",
      ClassificationDescription: "Classification description",
      ParentCategory: "Parent category",
      operation: "Operation",
      // popup
      categoryEdit: "Edit category",
      categoryCreate: "New category",
      tabTitle1: "Superior name",
      tabTitle2: "Please choose the superior name",
      tabTitle3: "Category icon",
      tabTitle4: "Classif. desc",
      tabTitle5: "Please enter the category description",
      tabTitle6: "Please enter the category name.",
    },
    materialDetail: {
      AssetDetails: "Asset details",
      BasicInformation: "Basic information",
      MaterialName: "Material Name",
      OriginalName: "Original name",
      MaterialClassification: "Material classification",
      ParentCategory: "Parent category",
      AssetInformation: "Asset information",
      materialType: "Material type",
      MaterialFormat: "Material format",
      MaterialDimensions: "Material dimensions",
      FileSize: "File size",
      OtherInformation: "Other information",
      Uploader: "Uploader",
      UploadTime: "Upload time",
      ValidityPeriod: "Validity Period",
      RecentlyModified: "Recently modified",
      TagInformation: "Tag information",
      NoTagsAvailable: "No Tags Available",
      MaterialPerformance: "Material performance",
      Last7Days: "Last 7 days",
      Last30Days: "Last 30 days",
      Last90Days: "Last 90 days",
      WebsiteTraffic: "Website traffic",
      DownloadCount: "Download count",
    },
    memberCenter: {
      addRules: "Add Rules",
      editRules: "Edit Rules",
      viewRules: "View Rules",
      pointsRules: "Points Rules",
      memberCenter: "Member Center",
      memberDetail: "Member Details",
      memberList: "Member List",
      memberCombine: "Member Combination",
      combineAccount: "Combine Accounts",
      memberPoints: "Member Points",
      individualInsight: "Individual Insight",
      memberEvent: "Member Event",
      addMemberEvent: "Add Member Event",
      editMemberEvent: "Edit Member Event",
      registerGiftsConfig: "Registration Gift Configuration",
      phone: "Phone",
      phoneNumber: "Phone Number",
      memberName: "Member Name",
      memberNickName: "Member Nickname",
      memberID: "Member ID",
      realName: "Real Name",
      nickName: "Nickname",
      sex: "Gender",
      memberSex: "Member Gender",
      birthday: "Birthday",
      birthdayDate: "Birthday Date",
      email: "Email",
      country: "Country",
      registerTime: "Registration Time",
      firstRegisterChannel: "First Registration Channel",
      buyChannel: "Purchase Channel",
      buyStore: "Purchase Store",
      subChannel: "Sub-channel",
      isEmployee: "Is Employee",
      isTermsOfAuthorization: "Is Terms Authorized",
      subscribeToMessageEmails: "Subscribe to Message Emails",
      subscribeToNewsletters: "Subscribe to Newsletters",
      subscribeToMessageSMS: "Subscribe to Message SMS",
      subscribeToMessagePhone: "Subscribe to Message Phone Calls",
      addMember: "Add Member",
      editMember: "Edit Member",
      locationArea: "Location Area",
      thirdID: "Third ID",
      presetExtensionAttr: "Preset Extension Attributes",
      firstRegisterChannelPl: "Please select the first registration channel",
      locationAreaPl: "Please select the location area",
      thirdIDPl: "Please enter the Third ID",
      presetExtensionAttrPl: "Please enter the preset extension attributes",
      phonePl: "Please enter the phone number",
      memberNamePl: "Please enter the member name",
      memberNickNamePl: "Please enter the member nickname",
      memberIDPl: "Please enter the member ID",
      realNamePl: "Please enter the real name",
      phoneNumberPl: "Please enter the phone number",
      nickNamePl: "Please enter the nickname",
      sexPl: "Please select the gender",
      emailPl: "Please enter the email",
      countryPl: "Please enter the country",
      birthdayPl: "Please select the birthday",
      pointsOverview: "Points Overview",
      changelog: "Change Log",
      validCredits: "Valid Credits",
      yesterdayAddNewPoints: "New Points Added Yesterday",
      yesterdaySpentPoints: "Points Spent Yesterday",
      pointsExchangeRate: "Points Exchange Rate",
      exchangeRateSettings: "Exchange Rate Settings",
      changeTime: "Change Time",
      changeType: "Change Type",
      events: "Events",
      pointsDetail: "Points Transaction Details",
      changeReason: "Change Reason",
      changeDescription: "Change Description",
      changeTimePl: "Please select the change time",
      changeTypePl: "Please select the change type",
      eventsPl: "Please select the event",
      changePoints: "Points Changed",
      changeReasonPl: "Please select the change reason",
      changeDescriptionPl: "Please enter the change description",
      changePointsPl: "Please enter the points changed",
      pointsConfig: "Points Configuration",
      rulesName: "Rule Name",
      startAndEndDate: "Start and End Dates",
      priority: "Priority",
      rulesStatus: "Rule Status",
      rulesType: "Rule Type",
      rulesNamePl: "Please enter the rule name",
      startAndEndDatePl: "Please select the start and end dates",
      priorityPl: "Please enter the priority",
      rulesStatusPl: "Please select the rule status",
      rulesTypePl: "Please select the rule type",
      rulesDescriptionPl: "Please enter the rule",
      basicConfig: "Basic Configuration",
      orderLimit: "Order Product Limit",
      eventName: "Event Name",
      eventKey: "Event Key",
      eventQuality: "Event Nature",
      eventType: "Event Type",
      eventRemark: "Event Remark",
      addEvent: "Add Event",
      tag: "Tag",
      tagName: "Tag Name",
      tagNamePl: "Please enter the tag name",
      bindStaticTag: "Bind Static Tag",
      eventNamePl: "Please enter the event name",
      eventKeyPl: "Please enter the event key",
      eventTypePl: "Please select the event type",
      addMemberEventConfirm: "Are you sure you want to save the member event?",
      addRuleConfirm: "Are you sure you want to save the rule?",
      addBaseConfigConfirm:
        "Are you sure you want to save the basic configuration?",
      correlationEvents: "Correlated Events",
      correlationEventsPl: "Please select the correlated events",
      limit: "Limit",
      natureWeek: "Natural Week",
      numberOfEngagements: "Number of Engagements",
      times: "Times",
      resetConfiguration: "Reset Configuration",
      resetRules: "Reset Rules",
      doNotReset: "Do Not Reset",
      naturalYearReset:
        "Reset points earned last year at the start of the new year",
      relativeValidityPeriodOfPoints: "Relative Validity Period of Points",
      expirationAfter: "Expires after",
      displayCopywritingConfiguration: "Display Content Configuration",
      displayCopywriting: "Display Content",
      goldBean: "Gold Beans",
      pointEventTypeConfig: "Points Event Type Configuration",
      pointEventLimitConfig: "Points Event Product Limit Configuration",
      noLimit: "No Limit",
      fixedTimeLimit: "Fixed Time Limit",
      maximumObtainableWithin: "Maximum obtainable within",
      onlyOnce: "Only given once",
      points: "Points",
      give: "Give",
      expiresAfter: "Expires after",
      subtitle:
        "Modifying the display content will change the external presentation of points for third-party system calls. For example, if the display content is 'Gold Beans', '800 points' will be displayed as '800 Gold Beans'.",
      subtitle1:
        "Points acquisition limit for events of type 'Number of Engagements'",
      subtitle2:
        "After consumers meet the above conditions, the product purchase event rules related to the above configurations will not take effect.",
      subtitle3:
        "Consumers who register through the following configured registration channels can receive the configured coupon package. They cannot receive it again if they register through other channels later.",
      subtitle4:
        "Consumers who register an account, then cancel it, and then re-register cannot receive this gift package again.",
      subtitle5: "Please select the account to be retained (primary account).",
      subtitle6:
        "Please confirm the above information. Click Confirm to merge the members if it is correct.",
      subtitle7: "Those who meet the above conditions will get X ",
      subtitle8: " times the points",
      subtitle9: "Coffee Capsules = ",
      subtitle10: "Select Coffee Capsules",
      reservedAccount: "Retained Account (Primary Account)",
      mergedAccounts: "Merged Accounts",
      sysEvent: "System Event",
      customEvent: "Custom Event",
      registerChannel: "Registration Channel",
      registerChannelPl: "Please select the registration channel",
      registerIssueCoupon: "Issue Channel Coupons upon Registration",
      addConsumptionVouchers: "Add Consumption Vouchers",
      bindPeople: "Bind People",
      memberIdentity: "Member Identity",
      commonlyUsedAddr: "Commonly Used Address",
      masterClass: "Master Class",
      reclaim: "Reclaim",
      subscribeToMessages: "Subscribe to Messages",
      subscribeToMessagesChannel: "Message Subscription Channel",
      auditRuleConfirmTitle: "Confirm Audit",
      auditRuleConfirmContent: "Are you sure you want to audit this rule?",
      auditCancelRuleConfirmTitle: "Confirm Cancel Audit",
      auditCancelRuleConfirmContent:
        "Are you sure you want to cancel the audit of this rule?",
      runRuleConfirmTitle: "Confirm Start",
      runRuleConfirmContent: "Are you sure you want to start this rule?",
      pauseRuleConfirmTitle: "Confirm Pause",
      pauseRuleConfirmContent: "Are you sure you want to pause this rule?",
      stopRuleConfirmTitle: "Confirm Termination",
      stopRuleConfirmContent: "Are you sure you want to terminate this rule",
      deleteRuleConfirmTitle: "Confirm Deletion",
      deleteRuleConfirmContent: "Are you sure you want to delete this rule?",
      bindSuccess: "Binding successful!",
      className: "Course Name",
      reservationStore: "Reservation Store",
      reclaimCount: "Reclaim Count",
      currentPoints: "Current Points",
      increaseAndDecrease: "Points Increase/Decrease",
      logoffAccountInfo: "Account Cancellation Information",
      logoffDesc: "Cancellation Description",
      everyTime: "Each participation",
    },

    orderCenter: {
      order: "Order",
      orderCenter: "Order Center",
      orderType: "Order Type",
      orderList: "Order List",
      orderStatus: "Order Status",
      orderNumber: "Order Number",
      channel: "Channel",
      shopName: "Shop Name",
      shop: "Shop",
      platformNick: "Platform Nickname",
      orderStatusPl: "Please select order status",
      orderTimePl: "Please select transaction time",
      orderNumberPl: "Please enter order number",
      channelPl: "Please select channel",
      shopNamePl: "Please enter shop name",
      platformNickPl: "Please enter platform nickname",
      tradeTime: "Transaction Time",
      tradeChannel: "Order Channel",
      merchandiseNum: "Product Quantity",
      orderTotal: "Order Total",
      amountPaidTotal: "Total Amount Paid",
      tradeStatus: "Transaction Status",
      refundOrder: "Refund Order",
      refundOrderDetail: "Refund Order Details",
      platformTrackingNumber: "Platform Tracking Number",
      refundTrackingNumber: "Refund Tracking Number",
      refundOrigin: "Refund Source",
      refundStatus: "Refund Status",
      refundLogID: "Refund Log ID",
      refundTotal: "Total Refund",
      refundStartTime: "Refund Initiation Time",
      refundEndTime: "Refund Completion Time",
      confirmTime: "User Confirmation Time",
      baseInfo: "Basic Information",
      refundDetail: "Refund Details",
      name: "Name",
      childOrderID: "Child Order ID",
      childOrderCount: "Number of Child Orders",
      productCategory: "Product Category",
      productType: "Product Type",
      refundNum: "Refund Quantity",
      refundAmount: "Refund Amount",
      baseItemCode: "Base Item Code",
      orderDetail: "Order Details",
      platformBuyerNick: "Platform Buyer Nickname",
      orderNo: "Order Number",
      buyerIdentityType: "Buyer Identity Type",
      buyerIdentityValue: "Buyer Identity Value",
      orderBrand: "Order Brand",
      orderPointsStatus: "Order Points Status",
      tradeInfo: "Transaction Information",
      paymentTime: "Payment Time",
      discountAmount: "Discount Amount",
      orderEndenTime: "Order End Time",
      paymentType: "Payment Type",
      numOfSpu: "Number of SPUs",
      numOfSku: "Number of SKUs",
      buyerConfirmTime: "Buyer Confirmation Time",
      refundTime: "Refund Time",
      sellerShippingTime: "Seller Shipping Time",
      consignee: "Consignee",
      orderTime: "Order Time",
      contactWay: "Contact Method",
      capsulePurchaseChannel: "Capsule Purchase Channel",
      chooseDoorTime: "Choose Door Time",
      consigneeInfo: "Consignee Information",
      consigneeName: "Consignee Name",
      consigneePhone: "Consignee Phone",
      consigneeRegion: "Consignee Region",
      consigneeProvince: "Consignee Province",
      consigneeCity: "Consignee City",
      shippingMethods: "Shipping Methods",
      consigneeAddress: "Consignee Address",
      consigneePostcode: "Consignee Postcode",
      shoppingGuideInformation: "Shopping Guide Information",
      guiderID: "Guider ID",
      guiderName: "Guider Name",
      duties: "Duties",
      storesID: "Store ID",
      storesName: "Store Name",
      storesType: "Store Type",
      belongRegion: "Belong Region",
      orderDetail1: "Order Details",
      discountInfo: "Discount Information",
      materialType: "Material Type",
      materialTypePl: "Please select material type",
      quantityPurchased: "Quantity Purchased",
      unitPrice: "Unit Price",
      giftCode: "Gift Code",
      childOrderAmountNo: "Child Order Discount Amount",
      childOrderAmountTotal: "Child Order Total Amount",
      childOrderActualPaymentAmount: "Child Order Actual Payment Amount",
      discountRemark: "Discount Remark",
      discountDesc: "Discount Description",
      subtitle:
        "Number of points for purchasing goods within the natural year is greater than:",
      subtitle1: "Please fill in material information",
      subtitle2: "Subscription Method",
      subtitle3: "Reminders and Subscriptions",
      subscription: "Subscription",
    },
    couponCenter: {
      currentDay: "Effective on the day of receipt,",
      couponCenter: "Coupon Center",
      couponCode: "Coupon Code",
      couponCodeID: "Coupon Code ID",
      couponCodeName: "Coupon Code Name",
      couponCodeType: "Coupon Code Type",
      couponCodeStatus: "Coupon Code Status",
      availability: "Available Time",
      couponCodeExpirationDate: "Coupon Code Expiration Date",
      distributionTotal: "Total Distribution",
      claimed: "Claimed",
      used: "Used",
      couponCodePl: "Please enter coupon code name",
      couponCodeTypePl: "Please select coupon code type",
      couponCodeStatusPl: "Please select coupon code status",
      oneCardOneCode: "One Card One Code",
      cashCouponCode: "Cash Coupon Code",
      oneCardOneCodeDesc: "Coupon code is unique and can only be used once",
      addNow: "Add Now",
      coupon: "Coupon",
      couponName: "Coupon Name",
      couponType: "Coupon Type",
      couponSelectPl: "Please select coupon",
      couponCountPl: "Please fill in coupon quantity",
      couponTypePl: "Please select coupon type",
      couponStatus: "Coupon Status",
      couponStatusPl: "Please select coupon status",
      couponID: "Coupon ID",
      couponIDPl: "Please select coupon ID",
      codeType: "Code Type",
      codeTypePl: "Please select code type",
      claimedAndRemainder: "Claimed/Remaining",
      couponExpirationDate: "Coupon Expiration Date",
      addCouponCode: "Add Coupon Code",
      addCouponCode1: "Add Coupon Code",
      batchDistributeCoupon: "Batch Distribute Coupon",
      batchDistributeCouponHistory: "Batch Distribute Coupon History",
      distributeCouponTime: "Distribute Coupon Time",
      distributeCouponNumber: "Distribute Coupon Number",
      couponTitle1: "Number of Coupons Distributed",
      couponTitle2: "Number of Failed Coupon Distributions",
      couponTitle3: "Download Failed List",
      baseInfo: "Basic Information",
      collectionAndUsageRules: "Collection and Usage Rules",
      subtitle1:
        "When modifying the total number of coupons, only increase is allowed, please set carefully",
      subtitle2:
        "Images only support jpeg, png, jpg formats, limited to 1 file, image size not exceeding 500 KB",
      subtitle3:
        "After creation, the total number can only be added in the 'Coupon Code List - Total Distribution', cannot be reduced, please set carefully",
      usageTime: "Available Time",
      applicableChannels: "Applicable Channels",
      allChannelUsage: "All Channels Available",
      fixedChannelUsage: "Specified Channels Available",
      limitClaimsPerPerson: "Limit Claims Per Person",
      title1: "Maximum per person",
      title2: "Maximum per person per day",
      title3: "Maximum per person per week",
      title4: "Maximum per person per month",
      title5: "Effective after",
      title6: "days,",
      precautions: "Usage Instructions",
      generateWay: "Generation Method",
      automaticallyGenerated: "Automatically Generated",
      importTheCodeLibrary: "Import Code Library",
      voucherName: "Voucher Name",
      dispatchCoupon: "Dispatch Coupon",
      memberId: "Member ID",
      phoneNumber: "Phone Number",
      memberPhoneNumber: "Member Phone Number",
      usercouponCode: "Coupon Code",
      userState: "State",
      getTime: "Get Time",
      getChannel: "Get Channel",
      getCode: "Coupon Code",
      stopUse: "Stop User Coupon",
      stopUseCode: "Stop User Code",
      stopUse2: "User Coupon Stopped",
      ConfirmContent: "Confirm to stop this user's coupon?",
      ConfirmContentCode: "Confirm to stop this user's code?",
      getUseListDetail: "Coupon Details",
      getUseListDetail1: "Code Details",
      codeId: "Coupon Code",
      useTpye: "Usage Status",
      creatTime: "Creation Time",
      addTotal: "Add Total",
      addStock: "Add Stock",
      editCouponCode: "Edit Coupon",
      editCouponCode1: "Edit Coupon Code",
      inviatationCode: "Invitation Code",
      campaignName: "Campaign Name",
      state: "State",
      batchDistributeinviatationCode: "Batch Generate Invitation Code",
      trueName: "True Name",
      expirationDate: "Expiration Date",
      useAndStock: "Used/Remaining",
      stop: "Pause",
      refresh: "Resume",
      addinviatationCode: "Generate Invitation Code",
      addinviatationCodeConfirm: "Confirm Generate Invitation Code",
      detailInviatationCode: "Invitation Code Details",
    },
    openApi: {
      openApi: "Open API",
      signManagement: "Signature Management",
      viewApi: "View API",
      signKey: "Signature Key",
      signKeyPl: "Please enter signature key",
      addSign: "Add Signature",
      signSecret: "Signature Secret",
      signSecretPl: "Please enter signature secret",
      channelName: "Channel Name",
      wechatAppID: "WeChat App ID",
      wechatAppIDPl: "Please enter WeChat App ID",
      channelNamePl: "Please enter channel name",
      callbackAddress: "Callback Address",
      callbackAddressPl: "Please enter callback address",
      updateInfo: "Update Information",
      updateSecret: "Update Secret",
      authorizationApi: "Authorization API",
      authorizationOpenApi: "Authorizable Open API",
      requestAddress: "Request Address",
      requestAddressPl: "Please enter request address",
      requestMethod: "Request Method",
      requestMethodPl: "Please select request method",
      requestHeader: "Request Header",
      requestHeaderPl: "Please enter request header",
      belongModule: "Belong Module",
      belongModulePl: "Please select belong module",
      apiDocument: "API Document",
      inputParameter: "Input Parameter",
      inputParameterPl: "Please enter input parameter",
      outputParameter: "Output Parameter",
      outputParameterPl: "Please enter output parameter",
      linkDesc: "Link Description",
      belongChannel: "Belong Channel",
      belongChannelPl: "Please select belong channel",
      whitelistIP: "Whitelist IP",
      leader: "Leader",
      sendExpertSms: "Send Expert SMS",
      marketingCenter: "Marketing Center",
      radioText1: "Open Api Member Coupon Controller Calculate Amount",
      radioText2: "Open Api Member Coupon Controller Lock",
      radioText3:
        "Open Api Member Coupon Controller Receive Code via Coupon Code",
      radioText4: "Tag Controller Member Tag List",
      radioText5: "Tag Controller Details",
      radioText6: "Delete Tag",
      radioText7: "Bind Tag",
      radioText8: "Unbind Tag",
      radioText9: "Tag Group Controller Group Details",
      radioText10: "Delete Group",
      radioText11: "null Member Attribute Field",
      radioText12: "Create/Update Order",
      radioText13: "Member Details",
      radioText14: "Member Channel Account Binding",
      radioText15: "Member Channel Account Update Member Channel Information",
      radioText16: "Order Details",
      tagCenter: "Tag Center",
    },
    metadata: {
      metadata: "Metadata",
      metadataManagement: "Metadata Management",
      dimensionInfoManagement: "Dimension Information Management",
      title1:
        "Consumers can receive the configured coupon package by registering on the configured registration channels; subsequent registration on other channels will not allow repeated receipt",
      title2:
        "If a consumer registers an account, cancels it, and then re-registers, they cannot receive this gift package again",
      title3: "Import Instructions",
      title4: "Download Import Template",
      title5: "Upload Import File",
      desc1:
        "Used for importing coffee machine types and points fields for basic materials",
      desc2:
        "Import is a full import, existing coffee machine types and points will be overwritten",
      desc3:
        "If coffee machine type/points are empty, the coffee machine/points will not be imported",
      desc4:
        "If coffee machine points need to be set to 0, please enter 0 in the points column in the template",
      desc5: "Please upload xlsx file",
      addCustomerRoles: "Add Customer Role",
      editCustomerRoles: "Edit Customer Role",
      identityName: "Identity Name",
      identityType: "Identity Type",
      identityCode: "Identity Code",
      identityManagement: "Identity Management",
      channelManagement: "Channel Management",
      storeManagement: "Store Management",
      basicMaterialManagement: "Basic Material Management",
      isUnique: "Is Unique",
      priority: "Priority",
      inheritance: "Inheritance",
      channelName: "Channel Name",
      brand: "Brand",
      platform: "Platform",
      addChannel: "Add Channel",
      editChannel: "Edit Channel",
      channelCode: "Channel Code",
      description: "Description",
      belongBrand: "Belong Brand",
      belongPlatform: "Belong Platform",
      defaultIdentityCode: "Default Identity Code",
      storeName: "Store Name",
      branchStoreName: "Branch Store Name",
      addStore: "Add Store",
      editStore: "Edit Store",
      storeNo: "Store Number",
      storeAddress: "Store Address",
      storePhone: "Store Phone",
      longitude: "Longitude",
      latitude: "Latitude",
      syncStore: "Sync Store",
      locationArea: "Location Area",
      detailAddress: "Detail Address",
      coffeeMakerTypeImport: "Coffee Maker Type Import",
      coffeeMakerType: "Coffee Maker Type",
      coffeeMakerTypeAndPointsImport: "Coffee Maker Type & Points Import",
      basicMaterialName: "Basic Material Name",
      basicMaterialCode: "Basic Material Code",
      materialType: "Material Type",
      basicMaterialNamePl: "Please enter basic material name",
      basicMaterialCodePl: "Please enter basic material code",
      brandName: "Brand Name",
      syncBasicMaterial: "Sync Basic Material",
      exportList: "Export List",
      buyPoints: "Buy Points",
      retailPrice: "Retail Price",
      getStoreListPage: "Get Store List Page",
    },
    blackAndWhiteList: {
      title1: "Smart Communication",
      title2: "Applicable Use Case",
      title3: "All Strategies",
      title4: "Partial Strategies",
      title5: "Long Term",
      title6: "Custom",
      title7: "Continue to Add",
      title8: "Error Reason",
      title9: "Continue to Edit",
      title10: "Total File Count",
      title11: "Download Error Report",
      title12: "Import Completed",
      title13: "Import Failed",
      title14: "Total File Count",
      title15: "Successfully Imported",
      title16: "Failed Count",
      placeholder2: "Please select applicable use case",
      blackAndWhiteList: "UnSubscribe Management",
      blackAndWhiteListManagement: "UnSubscribe Management",
      addList: "Add List",
      editList: "Edit List",
      viewList: "View List",
      importList: "Import List",
      downloadTemplate: "Download Template",
      listName: "List Name",
      listType: "List Type",
      listTypePl: "Please select list type",
      listType1: "Black List",
      listType2: "White List",
      confirmTip: "Confirm to delete this list?",
    },
  },
};
